import { FC } from 'react'
import styled from 'styled-components'

import { StepIndicatorItem } from './StepItem'

type StepProps = {
  /**
   * 0부터 시작
   */
  currentStep?: number
  steps?: {
    title: string
  }[]

  className?: string
}
export const StepIndicator: FC<StepProps> = ({ currentStep = 0, steps, className }) => {
  return (
    <StepIndicatorContainer className={className}>
      {steps?.map((item, index) => (
        <StepIndicatorItem
          key={index}
          title={item.title}
          step={index}
          active={index === currentStep}
          checked={index < currentStep}
        />
      ))}
    </StepIndicatorContainer>
  )
}

const StepIndicatorContainer = styled.div`
  display: flex;
  justify-content: space-between;
`
